export const SCREEN_NAME = 'repositoryJiraScreen';

export const MAX_ASSIGNEES_C0UNT = 5;
